/*!
 * ASP.NET SignalR JavaScript Library v2.3.0-rtm
 * http://signalr.net/
 *
 * Copyright (c) .NET Foundation. All rights reserved.
 * Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *
 */

/// <reference path="..\..\SignalR.Client.JS\Scripts\jquery-1.6.4.js" />
/// <reference path="jquery.signalR.js" />
(function ($, window, undefined) {
    /// <param name="$" type="jQuery" />
    "use strict";

    if (typeof ($.signalR) !== "function") {
        throw new Error("SignalR: SignalR is not loaded. Please ensure jquery.signalR-x.js is referenced before ~/signalr/js.");
    }

    var signalR = $.signalR;

    function makeProxyCallback(hub, callback) {
        return function () {
            // Call the client hub method
            callback.apply(hub, $.makeArray(arguments));
        };
    }

    function registerHubProxies(instance, shouldSubscribe) {
        var key, hub, memberKey, memberValue, subscriptionMethod;

        for (key in instance) {
            if (instance.hasOwnProperty(key)) {
                hub = instance[key];

                if (!(hub.hubName)) {
                    // Not a client hub
                    continue;
                }

                if (shouldSubscribe) {
                    // We want to subscribe to the hub events
                    subscriptionMethod = hub.on;
                } else {
                    // We want to unsubscribe from the hub events
                    subscriptionMethod = hub.off;
                }

                // Loop through all members on the hub and find client hub functions to subscribe/unsubscribe
                for (memberKey in hub.client) {
                    if (hub.client.hasOwnProperty(memberKey)) {
                        memberValue = hub.client[memberKey];

                        if (!$.isFunction(memberValue)) {
                            // Not a client hub function
                            continue;
                        }

                        // Use the actual user-provided callback as the "identity" value for the registration.
                        subscriptionMethod.call(hub, memberKey, makeProxyCallback(hub, memberValue), memberValue);
                    }
                }
            }
        }
    }

    $.hubConnection.prototype.createHubProxies = function () {
        var proxies = {};
        this.starting(function () {
            // Register the hub proxies as subscribed
            // (instance, shouldSubscribe)
            registerHubProxies(proxies, true);

            this._registerSubscribedHubs();
        }).disconnected(function () {
            // Unsubscribe all hub proxies when we "disconnect".  This is to ensure that we do not re-add functional call backs.
            // (instance, shouldSubscribe)
            registerHubProxies(proxies, false);
        });

        proxies['webDialerHub'] = this.createHubProxy('webDialerHub'); 
        proxies['webDialerHub'].client = { };
        proxies['webDialerHub'].server = {
            acceptCall: function (callcontext) {
            /// <summary>Calls the AcceptCall method on the server-side WebDialerHub hub.&#10;Returns a jQuery.Deferred() promise.</summary>
            /// <param name=\"callcontext\" type=\"Object\">Server side type is WorldDirect.Voice.WebDialer.Backend.Impl.WebDialerCall</param>
                return proxies['webDialerHub'].invoke.apply(proxies['webDialerHub'], $.merge(["AcceptCall"], $.makeArray(arguments)));
             },

            connect: function () {
            /// <summary>Calls the Connect method on the server-side WebDialerHub hub.&#10;Returns a jQuery.Deferred() promise.</summary>
                return proxies['webDialerHub'].invoke.apply(proxies['webDialerHub'], $.merge(["Connect"], $.makeArray(arguments)));
             },

            connectToPhoneByName: function (phoneName) {
            /// <summary>Calls the ConnectToPhoneByName method on the server-side WebDialerHub hub.&#10;Returns a jQuery.Deferred() promise.</summary>
            /// <param name=\"phoneName\" type=\"String\">Server side type is System.String</param>
                return proxies['webDialerHub'].invoke.apply(proxies['webDialerHub'], $.merge(["ConnectToPhoneByName"], $.makeArray(arguments)));
             },

            GetAllCallInformation: function () {
                /// <summary>Calls the GetAllCallInformation method on the server-side WebDialerHub hub.&#10;Returns a jQuery.Deferred() promise.</summary>
                return proxies['webDialerHub'].invoke.apply(proxies['webDialerHub'], $.merge(["GetAllCallInformation"], $.makeArray(arguments)));
            },

            getCallInformation: function () {
            /// <summary>Calls the GetCallInformation method on the server-side WebDialerHub hub.&#10;Returns a jQuery.Deferred() promise.</summary>
                return proxies['webDialerHub'].invoke.apply(proxies['webDialerHub'], $.merge(["GetCallInformation"], $.makeArray(arguments)));
             },

            getLineInformation: function () {
            /// <summary>Calls the GetLineInformation method on the server-side WebDialerHub hub.&#10;Returns a jQuery.Deferred() promise.</summary>
                return proxies['webDialerHub'].invoke.apply(proxies['webDialerHub'], $.merge(["GetLineInformation"], $.makeArray(arguments)));
             },

            holdCall: function (callToHold) {
            /// <summary>Calls the HoldCall method on the server-side WebDialerHub hub.&#10;Returns a jQuery.Deferred() promise.</summary>
            /// <param name=\"callToHold\" type=\"Object\">Server side type is WorldDirect.Voice.WebDialer.Backend.Impl.WebDialerCall</param>
                return proxies['webDialerHub'].invoke.apply(proxies['webDialerHub'], $.merge(["HoldCall"], $.makeArray(arguments)));
             },

            makeCall: function (callcontext) {
            /// <summary>Calls the MakeCall method on the server-side WebDialerHub hub.&#10;Returns a jQuery.Deferred() promise.</summary>
            /// <param name=\"callcontext\" type=\"Object\">Server side type is WorldDirect.Voice.WebDialer.Backend.Impl.WebDialerCall</param>
                return proxies['webDialerHub'].invoke.apply(proxies['webDialerHub'], $.merge(["MakeCall"], $.makeArray(arguments)));
             },

            stopCall: function (callcontext) {
            /// <summary>Calls the StopCall method on the server-side WebDialerHub hub.&#10;Returns a jQuery.Deferred() promise.</summary>
            /// <param name=\"callcontext\" type=\"Object\">Server side type is WorldDirect.Voice.WebDialer.Backend.Impl.WebDialerCall</param>
                return proxies['webDialerHub'].invoke.apply(proxies['webDialerHub'], $.merge(["StopCall"], $.makeArray(arguments)));
             },

            transferCall: function (callToTransfer, numberToTransferTo) {
            /// <summary>Calls the TransferCall method on the server-side WebDialerHub hub.&#10;Returns a jQuery.Deferred() promise.</summary>
            /// <param name=\"callToTransfer\" type=\"Object\">Server side type is WorldDirect.Voice.WebDialer.Backend.Impl.WebDialerCall</param>
            /// <param name=\"numberToTransferTo\" type=\"String\">Server side type is System.String</param>
                return proxies['webDialerHub'].invoke.apply(proxies['webDialerHub'], $.merge(["TransferCall"], $.makeArray(arguments)));
             },

            unHoldCall: function (callToUnHold) {
            /// <summary>Calls the UnHoldCall method on the server-side WebDialerHub hub.&#10;Returns a jQuery.Deferred() promise.</summary>
            /// <param name=\"callToUnHold\" type=\"Object\">Server side type is WorldDirect.Voice.WebDialer.Backend.Impl.WebDialerCall</param>
                return proxies['webDialerHub'].invoke.apply(proxies['webDialerHub'], $.merge(["UnHoldCall"], $.makeArray(arguments)));
             }
        };

        return proxies;
    };

    signalR.hub = $.hubConnection("/signalr", { useDefaultPath: false });
    $.extend(signalR, signalR.hub.createHubProxies());

}(window.jQuery, window));
